import React from "react";
import "./style.scss";

const AvatarModal = (props) => {
  return (
    <div className="avatarModal">
      <div className="avatarModal-header">Click on your new avatar</div>
      <div className="avatarModal-body">
        <div className="avatarModal-body-group">
          <div
            className="avatarModal-body-group-image"
            onClick={() => props.handleClickImage(0)}
          >
            <img
              alt="avatar1"
              src={require("./../../assets/images/0.svg")}
            ></img>
            <div className="avatarModal-body-group-image-overlay"></div>
          </div>
          <div
            className="avatarModal-body-group-image"
            onClick={() => props.handleClickImage(1)}
          >
            <img
              alt="avatar1"
              src={require("./../../assets/images/1.svg")}
            ></img>
            <div className="avatarModal-body-group-image-overlay"></div>
          </div>
          <div
            className="avatarModal-body-group-image"
            onClick={() => props.handleClickImage(2)}
          >
            <img
              alt="avatar1"
              src={require("./../../assets/images/2.svg")}
            ></img>
            <div className="avatarModal-body-group-image-overlay"></div>
          </div>
          <div
            className="avatarModal-body-group-image"
            onClick={() => props.handleClickImage(3)}
          >
            <img
              alt="avatar1"
              src={require("./../../assets/images/3.svg")}
            ></img>
            <div className="avatarModal-body-group-image-overlay"></div>
          </div>
        </div>
        <div className="avatarModal-body-group">
          <div
            className="avatarModal-body-group-image"
            onClick={() => props.handleClickImage(4)}
          >
            <img
              alt="avatar1"
              src={require("./../../assets/images/4.svg")}
            ></img>
            <div className="avatarModal-body-group-image-overlay"></div>
          </div>
          <div
            className="avatarModal-body-group-image"
            onClick={() => props.handleClickImage(5)}
          >
            <img
              alt="avatar1"
              src={require("./../../assets/images/5.svg")}
            ></img>
            <div className="avatarModal-body-group-image-overlay"></div>
          </div>
          <div
            className="avatarModal-body-group-image"
            onClick={() => props.handleClickImage(6)}
          >
            <img
              alt="avatar1"
              src={require("./../../assets/images/6.svg")}
            ></img>
            <div className="avatarModal-body-group-image-overlay"></div>
          </div>
          <div
            className="avatarModal-body-group-image"
            onClick={() => props.handleClickImage(7)}
          >
            <img
              alt="avatar1"
              src={require("./../../assets/images/7.svg")}
            ></img>
            <div className="avatarModal-body-group-image-overlay"></div>
          </div>
        </div>
        <div className="avatarModal-body-group">
          <div
            className="avatarModal-body-group-image"
            onClick={() => props.handleClickImage(8)}
          >
            <img
              alt="avatar1"
              src={require("./../../assets/images/8.svg")}
            ></img>
            <div className="avatarModal-body-group-image-overlay"></div>
          </div>
          <div
            className="avatarModal-body-group-image"
            onClick={() => props.handleClickImage(9)}
          >
            <img
              alt="avatar1"
              src={require("./../../assets/images/9.svg")}
            ></img>
            <div className="avatarModal-body-group-image-overlay"></div>
          </div>
          <div
            className="avatarModal-body-group-image"
            onClick={() => props.handleClickImage(10)}
          >
            <img
              alt="avatar1"
              src={require("./../../assets/images/10.svg")}
            ></img>
            <div className="avatarModal-body-group-image-overlay"></div>
          </div>
          <div
            className="avatarModal-body-group-image"
            onClick={() => props.handleClickImage(11)}
          >
            <img
              alt="avatar1"
              src={require("./../../assets/images/11.svg")}
            ></img>
            <div className="avatarModal-body-group-image-overlay"></div>
          </div>
        </div>
        <div className="avatarModal-body-button">
          <img
            alt="close"
            src={require("../../assets/images/close.svg")}
            onClick={props.handleCloseModal}
          ></img>
        </div>
      </div>
    </div>
  );
};
export default AvatarModal;
